<template>
  <div class="FormCertificate">
    <v-easy-dialog v-model="simpleDialog">
      <div class="flex flex-col v-card textSend">
        <div>
          <p class="titleModal">
            <strong>
              Confirmamos la recepción de la solicitud. A continuación los pasos a seguir para la emisión del certificado:
            </strong>
          </p>
        </div>
        <hr />

        <div class="infoModal">
          <p>1. Realiza el pago de tu recibo en línea o descárgalo para pago en entidad financiera.</p>

          <template v-if="!isSpecialSuccessModalCert(lastSuccessCertLabel)">
            <p>
              2. Una vez realizado el pago adjunta el soporte en
              <a href="http://campus.ibero.edu.co/recibo-pago-certificado" target="_blank">
                <strong>"Soporte de pago Certificaciones"</strong>
              </a>.
              Ten en cuenta que debes tener a la mano el número de radicado de esta solicitud.
            </p>

            <p>
              3. Después de recibido el comprobante de pago; inicia el trámite de expedición del certificado por parte del
              área de Registro y control en 2 días hábiles y para los certificados de practicas 6 dias habiles.
            </p>
          </template>

          <div v-else>
            <p>2. Una vez recibido el pago:</p>
            <ul style="list-style-type: disc; padding-left: 20px; margin-left: 18px;">
              <li>Si pagas en línea, el certificado será generado dentro de las siguientes 24 horas.</li>
              <li>Si realizas el pago en entidad financiera, el certificado será generado en un plazo de hasta 2 días hábiles.</li>
            </ul>
          </div>
        </div>

        <div class="flex justify-end space-x-2">
          <button id="btnClose" v-on:click="closeModal" style="float: right;">Paga o descarga tu recibo aquí</button>
        </div>
      </div>
    </v-easy-dialog>

    <v-easy-dialog v-model="dialogAditional">
      <div class="flex flex-col v-card textSend">
        <div>
          <p class="titleModal"><strong>Atención</strong></p>
        </div>
        <hr />
        <div class="infoModal">
          <p>El Certificado de Giro Adicional no requiere pago. Por favor adjuntar la carta de solicitud.</p>
        </div>

        <div class="flex justify-end space-x-2">
          <button id="btnClose" @click="closeModalAditional" style="float: right;">Cerrar</button>
        </div>
      </div>
    </v-easy-dialog>

    <v-easy-dialog v-model="dialogServiceError">
      <div class="flex flex-col v-card textSend">
        <div>
          <p class="titleModal"><strong>Error</strong></p>
        </div>
        <hr />
        <div class="infoModal">
          <p>No fue posible validar tu información. Por favor comunícate con servicio al estudiante.</p>
        </div>

        <div class="flex justify-end space-x-2">
          <button id="btnClose" @click="dialogServiceError = false" style="float: right;">Cerrar</button>
        </div>
      </div>
    </v-easy-dialog>

    <div v-if="FormCertificate">
      <div class="container container-form">
        <div class="row">
          <div class="col-md-7 totalform motBusUser">
            <div v-if="infoCorrect" class="alert alert-success">
              <p>
                Gracias, Tu información ha sido recibida con éxito, se ha creado el caso y será atendido lo más pronto posible.
              </p>
            </div>

            <h1 class="titleForm"><strong>Certificaciones</strong></h1>

            <p class="descriptionForm">
              Para agilizar tus trámites y ahorrar tiempo puedes llenar el formulario a continuación para solicitar cualquier tipo de certificado que necesites.
              Ten en cuenta que utilizaremos el resto de tu información para actualizar tus datos y asegurarnos de poder estar siempre en contacto.
            </p>
            <p class="descriptionForm">
              Ten en cuenta las fechas establecidas en el calendario académico para la solicitud de tus certificados.
            </p>

            <div v-if="identityFieldsLocked" class="alert alert-info" style="margin-top: 10px;">
              <p style="margin: 0;">
                Tus datos fueron consultados y se muestran bloqueados para evitar cambios.
                Si no coinciden, actualiza tus datos aquí:
              </p>

              <div style="margin-top: 10px; display:flex; gap:10px; justify-content:flex-end;">
                <button type="button" class="loginbtn" @click="openPqrs">
                  Mis datos no coinciden
                </button>
              </div>
            </div>

            <ValidationObserver ref="obsformCertificate">
              <FormCertificate :FieldsForm="formCertificate" :ModelForm="formInsModel" :method="executeProcess" />
            </ValidationObserver>

            <div v-if="periodsLoading" class="alert alert-info period-loading-message">
              <p style="margin: 0;">
                Estamos cargando los periodos academicos disponibles. En cuanto termine la consulta podras seleccionar el periodo.
              </p>
            </div>

            <div class="botoPnrocess">
              <div class="container">
                <div class="row">
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <button id="UpdateUser" type="submit" v-on:click="UpdateUser" class="loginbtn" :disabled="periodsLoading">
                      Validar datos
                    </button>
                  </div>
                  <div class="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-5 infoForm">
            <FormDataInscription />
          </div>
        </div>
      </div>
    </div>

    <div v-if="FormValidate">
      <div class="container container-form">
        <div class="row">
          <div class="col-md-2 infoForm"></div>
          <div class="col-md-8 totalform motBusUser">
            <div v-if="dangerData" class="alert alert-danger">
              <p>
                Error: {{ dangerDataMessage || 'Tus datos no han sido almacenados correctamente. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.' }}
              </p>
            </div>

            <div class="infoTitleValid">
              <p><strong>NOTA:</strong> Recuerda que, una vez solicitado el certificado, no es posible hacer ajustes al mismo.</p>
            </div>

            <div class="wrapper">
              <div><p><strong>Nombre(s)</strong></p></div>
              <div><p>{{ this.NamePerson }}</p></div>

              <div><p><strong>Apellido(s)</strong></p></div>
              <div><p>{{ this.LastnamePerson }}</p></div>

              <div><p><strong>Tipo de Identificación</strong></p></div>
              <div><p>{{ this.IdType }}</p></div>

              <div><p><strong>N° de Identificación</strong></p></div>
              <div><p>{{ this.Identification }}</p></div>

              <div><p><strong>Programa a Certificar</strong></p></div>
              <div><p>{{ this.Program }}</p></div>

              <div><p><strong>Periodo Académico a Certificar</strong></p></div>
              <div><p>{{ this.PeriodCertificate }}</p></div>

              <div><p><strong>Tipo de Certificado o Duplicado</strong></p></div>
              <div><p>{{ this.CertificateType }}</p></div>

              <div><p><strong>Cantidad de Periodos</strong></p></div>
              <div><p>{{ this.QuantityCertificate }}</p></div>

              <div><p><strong>Valor del Certificado</strong></p></div>
              <div><p>${{ this.ValueCertificate }}</p></div>
            </div>

            <div class="validate-data botoPnrocess">
              <div class="container">
                <p>¿Estás de acuerdo con la información digitada es correcta?</p>
                <div class="row">
                  <div class="col-md-4"></div>
                  <div class="col-md-4">
                    <button id="UpdateUser" type="submit" v-on:click="onComplete" class="validateBtn col-md-4">
                      Si
                    </button>
                    <button id="UpdateUser" type="submit" v-on:click="goBackForm" class="validateBtn col-md-4">
                      No
                    </button>
                  </div>
                  <div class="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 infoForm"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FormDataInscription from '@/views/InfoZone/FormCertificate.vue'
import FormCertificate from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import VEasyDialog from 'v-easy-dialog'

export default {
  name: "FormCertificated",
  components: {
    FormDataInscription,
    FormCertificate,
    VEasyDialog,
  },

  methods: {
    dataObjCheck: function(InfDaT){
      if(InfDaT === true){
        return this.$ml.get('Accepted');
      }
      return this.$ml.get('NotAccepted');
    },

    openPqrs() {
      window.open("https://campus.ibero.edu.co/formulario-pqrs", "_blank", "noopener");
    },

    closeModal: function () {
      this.simpleDialog = false;
      this.lastSuccessCertLabel = "";
      this.lastSuccessUseLegacyNotasFlow = false;

      window.open("https://icebergprod.ibero.edu.co/iceberg-pf/");
    },

    closeModalAditional: function () {
      this.dialogAditional = false;
    },
    setFieldHidden(fieldId, hidden) {
      const idx = this.formCertificate.findIndex(f => f.id === fieldId);
      if (idx !== -1) this.$set(this.formCertificate[idx], 'hidden', hidden);
    },
    setFieldDisabled(fieldId, disabled) {
      const idx = this.formCertificate.findIndex(f => f.id === fieldId);
      if (idx !== -1) this.$set(this.formCertificate[idx], 'disabled', disabled);
    },
    setFieldValidate(fieldId, validateObj) {
      const idx = this.formCertificate.findIndex(f => f.id === fieldId);
      if (idx !== -1) this.$set(this.formCertificate[idx], 'validate', validateObj);
    },
    toggleNewCertificateEmailField(show) {
      this.setFieldHidden("IdNewCertificateEmail", !show);
      this.setFieldDisabled("IdNewCertificateEmail", !show);
      this.setFieldValidate(
        "IdNewCertificateEmail",
        show ? { required: true, email: true } : { required: false, email: true }
      );

      if (!show) {
        this.formInsModel.IdNewCertificateEmail = '';
      }
    },
    getCertificateRecipientEmail() {
      const newEmail = String(this.formInsModel.IdNewCertificateEmail || '').trim();

      if (this.formInsModel.UseNewCertificateEmail && newEmail !== '') {
        return newEmail;
      }

      return String(this.formInsModel.IdIberoMail || '').trim();
    },
    resetCertificateSubmitError() {
      this.dangerData = false;
      this.dangerDataMessage = "";
    },
    getCertificateSubmitStatus(response) {
      if (!response) return "";

      const responseStatus = response.data && response.data.status !== undefined && response.data.status !== null
        ? response.data.status
        : response.status;

      if (responseStatus === undefined || responseStatus === null) return "";
      return String(responseStatus).trim();
    },
    getCertificateSubmitErrorMessage(response, fallbackMessage = "") {
      const candidates = [
        response && response.data ? response.data.message : "",
        response && response.data ? response.data.title : "",
        fallbackMessage,
      ];

      const resolvedMessage = candidates.find((message) => typeof message === "string" && message.trim() !== "");

      return resolvedMessage || "Tus datos no han sido almacenados correctamente. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.";
    },
    showCertificateSubmitError(response, fallbackMessage = "") {
      this.dangerDataMessage = this.getCertificateSubmitErrorMessage(response, fallbackMessage);
      this.dangerData = true;
      IberoHelpers.scrollToTop(0,100);
    },
    setIdentityFieldsLocked(locked) {
      this.identityFieldsLocked = !!locked;
      const ids = ["IdNombres", "IdApellidos", "IdBanner", "IdMail", "IdIberoMail"];
      ids.forEach((id) => this.setFieldDisabled(id, locked));
      const roMap = ["IdNombres", "IdApellidos", "IdBanner", "IdMail", "IdIberoMail"];
      roMap.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.readOnly = locked;
      });
    },
    toggleCellphoneField(hide) {
      this.setFieldHidden("IdCellphone", hide);
      this.setFieldDisabled("IdCellphone", hide);

      if (hide) {
        this.setFieldValidate("IdCellphone", { required: false, numeric: true, max: 10, min: 10 });
      } else {
        this.setFieldValidate("IdCellphone", { required: true, numeric: true, max: 10, min: 10 });
      }
    },

    getSelectedCertificateLabel() {
      if (!this.formInsModel.IdCertificateType) return "";
      return IberoHelpers.dataObjFind(this.$store.state.CertificatesList, this.formInsModel.IdCertificateType) || "";
    },
    getPeriodNumber(periodValue) {
      const n = parseInt(String(periodValue || '').trim(), 10);
      return Number.isFinite(n) ? n : null;
    },
    isNotasCert(label) {
      return label === "Certificado de Notas (Materias créditos y promedio semestral y general)";
    },
    shouldUseLegacyNotasFlow() {
      const p = this.getPeriodNumber(this.formInsModel.IdPeriod);
      if (p === null) return false;
      return p < 202300;
    },
    isNotasNewFlow() {
      const label = this.getSelectedCertificateLabel();
      return this.isNotasCert(label) && !this.shouldUseLegacyNotasFlow();
    },
    refreshNotasFlowFlagAndUI() {
      this.formInsModel.UseLegacyFlowNotas = this.shouldUseLegacyNotasFlow();

      const label = this.getSelectedCertificateLabel();
      this.setFieldHidden("IsHomologation", true);

      if (!this.isNotasCert(label)) {
        this.setFieldHidden("IsCurPeriod", true);
        this.formInsModel.IsCurPeriod = false;
        return;
      }

      const showExtras = this.isNotasNewFlow();
      this.setFieldHidden("IsCurPeriod", !showExtras);

      if (!showExtras) {
        this.formInsModel.IsHomologation = false;
        this.formInsModel.IsCurPeriod = false;
      }
    },
    certificateUsesAutomaticHomologation(certificateLabel) {
      return this.CERTS_AUTO_HOMOLOGATION.includes(certificateLabel);
    },
    shouldResolveAutomaticHomologation(certificateLabel = this.getSelectedCertificateLabel()) {
      if (!this.certificateUsesAutomaticHomologation(certificateLabel)) return false;

      const idBanner = String(this.formInsModel.IdBanner || '').trim();
      const period = String(this.formInsModel.IdPeriod || '').trim();
      if (!idBanner || !period) return false;

      if (this.isNotasCert(certificateLabel) && this.shouldUseLegacyNotasFlow()) {
        return false;
      }

      return true;
    },
    normalizeBooleanFlag(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "string") return value.trim().toLowerCase() === "true";
      if (typeof value === "number") return value === 1;
      return false;
    },
    requestAutomaticHomologation(payload) {
      if (typeof IberoHelpers.findStudentHomologationCertificate === "function") {
        return IberoHelpers.findStudentHomologationCertificate(this.$store, payload);
      }

      return axios.get(
        this.$store.state.ApiIbero.WSUtilitary +
        'Certificate/InformationPersonHomologation/' +
        payload.IdBanner + '/' +
        payload.IdPeriod
      );
    },
    async resolveAutomaticHomologation() {
      const certificateLabel = this.getSelectedCertificateLabel();

      if (!this.shouldResolveAutomaticHomologation(certificateLabel)) {
        this.formInsModel.IsHomologation = false;
        return false;
      }

      const response = await this.requestAutomaticHomologation({
        IdBanner: this.formInsModel.IdBanner,
        IdPeriod: this.formInsModel.IdPeriod,
      });

      if (response === false) {
        this.formInsModel.IsHomologation = false;
        return false;
      }

      this.formInsModel.IsHomologation = this.normalizeBooleanFlag(response.data);
      return this.formInsModel.IsHomologation;
    },
    startAutomaticHomologationLookup(force = false) {
      if (!force && this.pendingHomologationPromise) {
        return this.pendingHomologationPromise;
      }

      if (!this.shouldResolveAutomaticHomologation()) {
        this.pendingHomologationPromise = null;
        this.formInsModel.IsHomologation = false;
        return Promise.resolve(false);
      }

      const request = this.resolveAutomaticHomologation()
        .catch((error) => {
          console.log(error);
          this.formInsModel.IsHomologation = false;
          return false;
        })
        .finally(() => {
          if (this.pendingHomologationPromise === request) {
            this.pendingHomologationPromise = null;
          }
        });

      this.pendingHomologationPromise = request;
      return request;
    },
    isSpecialSuccessModalCert(certificateLabel) {
      if (!this.CERTS_SPECIAL_SUCCESS_MODAL.includes(certificateLabel)) return false;
      if (this.isNotasCert(certificateLabel)) {
        return !this.lastSuccessUseLegacyNotasFlow;
      }
      return true;
    },

    certificateRequiresPeriod(certificateLabel) {
      return this.CERTS_REQUIRE_PERIOD.includes(certificateLabel);
    },

    getLegacyPeriodOptions() {
      return Array.from({ length: 10 }, (_, index) => {
        const value = String(index + 1);
        return { id: value, value };
      });
    },

    togglePeriodField(show) {
      if (show) {
        this.setFieldHidden("IdPeriod", false);
        this.setFieldDisabled("IdPeriod", true);
        this.setFieldValidate("IdPeriod", { required: true });
      } else if (this.getSelectedCertificateLabel()) {
        this.setLegacyPeriodOptions();
        this.setFieldValidate("IdPeriod", { required: true });
      } else {
        this.setFieldValidate("IdPeriod", { required: false });
        this.clearPeriods();
      }
    },
    parseProgramsResponse(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;

      if (typeof data === "string") {
        try {
          const parsed = JSON.parse(data);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    setProgramOptions(programs) {
      const options = (programs || [])
        .map(p => ({
          id: p.CodPrograma || p.codPrograma || p.id,
          value: p.Programa || p.programa || p.value
        }))
        .filter(x => x.id && x.value);

      const idx = this.formCertificate.findIndex(f => f.id === "IdProgram");
      if (idx !== -1) {
        this.formCertificate[idx].values = options;
      }

      this.formInsModel.IdProgram = "";
      this.clearPeriods();
    },

    restoreGlobalPrograms() {
      const idx = this.formCertificate.findIndex(f => f.id === "IdProgram");
      if (idx !== -1) {
        this.formCertificate[idx].values = this.$store.state.ProgramsList;
      }
      this.formInsModel.IdProgram = "";
      this.clearPeriods();
    },
    parsePeriodsResponse(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;

      if (typeof data === "string") {
        try {
          const parsed = JSON.parse(data);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    setPeriodOptions(periods) {
      const options = (periods || [])
        .map(p => ({
          id: p.IdPeriodo || p.idPeriodo || p.id,
          value: p.Periodo || p.periodo || p.value
        }))
        .filter(x => x.id && x.value);

      const idx = this.formCertificate.findIndex(f => f.id === "IdPeriod");
      if (idx !== -1) {
        this.formCertificate[idx].values = options;
        this.$set(this.formCertificate[idx], 'hidden', false);
        this.$set(this.formCertificate[idx], 'disabled', false);
      }
    },

    setLegacyPeriodOptions() {
      const options = this.getLegacyPeriodOptions();
      const idx = this.formCertificate.findIndex(f => f.id === "IdPeriod");

      if (idx !== -1) {
        this.formCertificate[idx].values = options;
        this.$set(this.formCertificate[idx], 'hidden', false);
        this.$set(this.formCertificate[idx], 'disabled', false);
      }

      const currentValue = String(this.formInsModel.IdPeriod || "").trim();
      const hasCurrentValue = options.some(option => option.id === currentValue);

      if (!hasCurrentValue) {
        this.formInsModel.IdPeriod = "";
      }
    },

    clearPeriods() {
      this.periodsRequestId += 1;
      this.periodsLoading = false;
      const idx = this.formCertificate.findIndex(f => f.id === "IdPeriod");
      if (idx !== -1) {
        this.formCertificate[idx].values = [];
        this.$set(this.formCertificate[idx], 'hidden', true);
        this.$set(this.formCertificate[idx], 'disabled', true);
      }
      this.formInsModel.IdPeriod = "";
      this.formInsModel.IsHomologation = false;
      this.refreshNotasFlowFlagAndUI();
    },

    async loadPeriodsByProgram() {
      const certLabel = this.getSelectedCertificateLabel();
      if (!certLabel) {
        this.clearPeriods();
        return;
      }

      const needsDynamicPeriods = this.certificateRequiresPeriod(certLabel);

      if (!needsDynamicPeriods) {
        this.periodsRequestId += 1;
        this.periodsLoading = false;
        this.setLegacyPeriodOptions();
        this.setFieldValidate("IdPeriod", { required: true });
        this.formInsModel.IsHomologation = false;
        this.refreshNotasFlowFlagAndUI();
        return;
      }

      if (!this.formInsModel.IdDocumentType || !this.formInsModel.IdDocument || !this.formInsModel.IdProgram) {
        this.clearPeriods();
        return;
      }

      const idx = this.formCertificate.findIndex(f => f.id === "IdPeriod");
      if (idx !== -1) {
        this.$set(this.formCertificate[idx], 'hidden', false);
        this.$set(this.formCertificate[idx], 'disabled', true);
      }

      this.formInsModel.IdPeriod = "";

      const requestId = ++this.periodsRequestId;
      this.periodsLoading = true;

      try {
        const respPeriods = await IberoHelpers.findStudentPeriodsCertificate(this.$store, this.formInsModel);

        if (requestId !== this.periodsRequestId) {
          return;
        }

        if (respPeriods && respPeriods.data) {
          const periods = this.parsePeriodsResponse(respPeriods.data);

          if (periods.length > 0) {
            this.setPeriodOptions(periods);

            if (periods.length === 1) {
              const p = periods[0];
              this.formInsModel.IdPeriod = (p.IdPeriodo || p.idPeriodo || "");
            }
            this.refreshNotasFlowFlagAndUI();
          } else {
            this.clearPeriods();
          }
        } else {
          this.clearPeriods();
        }
      } finally {
        if (requestId === this.periodsRequestId) {
          this.periodsLoading = false;
        }
      }
    },
    async fetchDataOnDocumentClearIfPossible() {
      const snapType = (this.lastDocSnapshot.type || "").trim();
      const snapDoc = (this.lastDocSnapshot.doc || "").trim();

      if (!snapType || !snapDoc) return false;

      const payload = {
        ...this.formInsModel,
        IdDocumentType: snapType,
        IdDocument: snapDoc
      };

      try {
        const resp = await IberoHelpers.findStudentCertificate(this.$store, payload);

        if (resp && resp.data !== '') {
          this.infoData = false;
          this.studentDataLoaded = true;

          this.loadFindData(resp.data);
          this.setIdentityFieldsLocked(true);
          this.toggleCellphoneField(true);
          const respPrograms = await IberoHelpers.findStudentProgramsCertificate(this.$store, payload);

          if (respPrograms && respPrograms.data) {
            const programs = this.parseProgramsResponse(respPrograms.data);

            if (programs.length > 0) {
              this.setProgramOptions(programs);
            } else {
              this.restoreGlobalPrograms();
              this.clearPeriods();
            }
          } else {
            this.restoreGlobalPrograms();
            this.clearPeriods();
          }

          this.refreshNotasFlowFlagAndUI();
          return true;
        }
      } catch (e) {
      }

      return false;
    },
    loadFindData: function(restJson){
      document.getElementById("IdNombres").readOnly = true;
      document.getElementById("IdApellidos").readOnly = true;
      document.getElementById("IdBanner").readOnly = true;

      this.setFieldHidden("IdQuantity", true);
      this.setFieldHidden("IdPractice", true);

      this.formInsModel.IdNombres = restJson.Nombres
      this.formInsModel.IdApellidos = restJson.Apellidos
      this.formInsModel.IdBanner = restJson.IdBanner
      this.formInsModel.IdCellphone = restJson.Celular
      this.formInsModel.IdMail = restJson.EmailPersonal

      const inst = (restJson.EmailInstitucional || '').trim();
      this.formInsModel.IdIberoMail = (inst && inst.toLowerCase() !== 'no tiene') ? inst : '';
      this.formInsModel.UseNewCertificateEmail = false
      this.formInsModel.IdNewCertificateEmail = ''

      this.formInsModel.IdModality = restJson.Modalidad
      this.formInsModel.IdWorking = restJson.Jornada

      this.toggleNewCertificateEmailField(false);
    },

    clearFields: function(){
      document.getElementById("IdNombres").readOnly = false;
      document.getElementById("IdApellidos").readOnly = false;
      document.getElementById("IdBanner").readOnly = false;

      this.formInsModel.IdNombres = ''
      this.formInsModel.IdApellidos = ''
      this.formInsModel.IdBanner = ''
      this.formInsModel.IdCellphone = ''
      this.formInsModel.IdMail = ''
      this.formInsModel.UseNewCertificateEmail = false
      this.formInsModel.IdNewCertificateEmail = ''
      this.formInsModel.IdIberoMail = ''
      this.formInsModel.IdProgram = ''
      this.formInsModel.IdModality = ''
      this.formInsModel.IdWorking = ''
      this.formInsModel.IdPeriod = ''
      this.formInsModel.IdQuantity = ''
      this.formInsModel.IdPractice = ''

      this.clearPeriods();
      this.setFieldHidden("IdQuantity", true);
      this.setFieldHidden("IdPractice", true);

      this.toggleCellphoneField(false);
      this.setIdentityFieldsLocked(false);

      this.toggleNewCertificateEmailField(false);
    },

    dataformat: function(InfDaT){
      return IberoHelpers.dataObjDate(InfDaT);
    },

    dataObjFindJs: function(infoDaT,FinDaT){
      return IberoHelpers.dataObjFind(infoDaT,FinDaT);
    },

    dataObjAllFind: function(infoDaT,FinDaT){
      return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
    },
    executeProcess: function (event){
      switch (event.target.id){
        case "IdDocumentType":
          this.formInsModel.IdDocument = '';
          this.restoreGlobalPrograms();
          this.clearPeriods();

          this.studentDataLoaded = false;
          this.setIdentityFieldsLocked(false);
          this.toggleCellphoneField(false);
          this.lastDocSnapshot = { type: "", doc: "" };

          this.refreshNotasFlowFlagAndUI();
        break;

        case "IdDocument":
          if (this.formInsModel.IdDocumentType && this.formInsModel.IdDocument && String(this.formInsModel.IdDocument).trim() !== "") {
            this.lastDocSnapshot.type = this.formInsModel.IdDocumentType;
            this.lastDocSnapshot.doc = String(this.formInsModel.IdDocument).trim();
          }
          if (!this.formInsModel.IdDocument || (typeof this.formInsModel.IdDocument === 'string' && this.formInsModel.IdDocument.trim() === '')) {
            // Use promise chain instead of await
            this.fetchDataOnDocumentClearIfPossible().then(hadData => {
              if (hadData) {
                return;
              }

              this.studentDataLoaded = false;
              this.restoreGlobalPrograms();
              this.clearPeriods();

              this.setIdentityFieldsLocked(false);
              this.toggleCellphoneField(false);

              this.refreshNotasFlowFlagAndUI();
            }).catch(err => {
              console.error(err);
            });

            return;
          }
          if(event.type === 'blur' && this.formInsModel.IdDocumentType !== '' && this.formInsModel.IdDocument !== ''){
            this.clearPeriods();

            const pruebaUser = IberoHelpers.findStudentCertificate(this.$store, this.formInsModel);

            pruebaUser.then((Response) => {
              if (Response && Response.data !== '') {
                this.infoData = false;
                this.studentDataLoaded = true;

                this.loadFindData(Response.data);
                this.setIdentityFieldsLocked(true);
                this.toggleCellphoneField(true);

                IberoHelpers.findStudentProgramsCertificate(this.$store, this.formInsModel).then((respPrograms) => {
                  if (respPrograms && respPrograms.data) {
                    const programs = this.parseProgramsResponse(respPrograms.data);

                    if (programs.length > 0) {
                      this.setProgramOptions(programs);

                      if (programs.length === 1) {
                        const p = programs[0];
                        this.formInsModel.IdProgram = (p.CodPrograma || p.codPrograma || "");
                        this.loadPeriodsByProgram().catch(e => console.error(e));
                      } else {
                        if (Response.data && Response.data.CodPrograma) {
                          const exists = programs.some(x => (x.CodPrograma || x.codPrograma) === Response.data.CodPrograma);
                          if (exists) {
                            this.formInsModel.IdProgram = Response.data.CodPrograma;
                            this.loadPeriodsByProgram().catch(e => console.error(e));
                          }
                        }
                      }
                      this.refreshNotasFlowFlagAndUI();
                    } else {
                      this.restoreGlobalPrograms();
                      this.clearPeriods();
                      this.refreshNotasFlowFlagAndUI();
                    }
                  } else {
                    this.restoreGlobalPrograms();
                    this.clearPeriods();
                    this.refreshNotasFlowFlagAndUI();
                  }
                }).catch(e => {
                  console.error(e);
                  this.restoreGlobalPrograms();
                  this.clearPeriods();
                  this.refreshNotasFlowFlagAndUI();
                });
              } else {
                this.studentDataLoaded = false;

                this.clearFields();
                this.infoData = true;
                this.restoreGlobalPrograms();
                this.clearPeriods();

                this.setIdentityFieldsLocked(false);
                this.toggleCellphoneField(false);

                this.refreshNotasFlowFlagAndUI();
              }
            }).catch(e => {
              console.error(e);
            });
          }
        break;

        case "IdProgram": {
          const certLabel = this.getSelectedCertificateLabel();
          if (certLabel) {
            this.loadPeriodsByProgram().then(() => {
              this.refreshNotasFlowFlagAndUI();
            }).catch(e => {
              console.error(e);
              this.refreshNotasFlowFlagAndUI();
            });
            return;
          } else {
            this.clearPeriods();
          }
          this.refreshNotasFlowFlagAndUI();
          break;
        }

        case "IdPeriod": {
          this.refreshNotasFlowFlagAndUI();
          break;
        }

        case "cbox_UseNewCertificateEmail": {
          this.toggleNewCertificateEmailField(!!this.formInsModel.UseNewCertificateEmail);
          break;
        }

        case "IdCertificateType": {
          var resultado =  IberoHelpers.dataObjFind(this.$store.state.CertificatesList, this.formInsModel.IdCertificateType);
          this.setFieldHidden("IsHomologation", true);
          this.setFieldHidden("IsCurPeriod", true);
          this.formInsModel.IsHomologation = false;
          this.formInsModel.IsCurPeriod = false;

          const needsPeriod = this.certificateRequiresPeriod(resultado);
          this.togglePeriodField(needsPeriod);

          switch(resultado){
            case "Certificado de Notas (Materias créditos y promedio semestral y general)":
              this.refreshNotasFlowFlagAndUI();

              this.setFieldHidden("IdQuantity", true);
              this.formInsModel.IdQuantity = "";
              this.setFieldHidden("IdPractice", true);
              this.formInsModel.IdPractice = "";
            break;

            case "Certificado de Notas Totales":
              this.setFieldHidden("IdQuantity", false);
              this.setFieldHidden("IdPractice", true);
              this.formInsModel.IdPractice = "";
            break;

            case "Certificado Practicas":
              this.setFieldHidden("IdQuantity", true);
              this.formInsModel.IdQuantity = "";
              this.setFieldHidden("IdPractice", false);
            break;

            case "Certificado Giro Adicional":
              this.dialogAditional = true;
              this.setFieldHidden("IdQuantity", true);
              this.formInsModel.IdQuantity = "";
              this.setFieldHidden("IdPractice", true);
              this.formInsModel.IdPractice = "";
            break;

            default:
              this.setFieldHidden("IdQuantity", true);
              this.formInsModel.IdQuantity = "";
              this.setFieldHidden("IdPractice", true);
              this.formInsModel.IdPractice = "";
            break;
          }

          if (resultado) {
            this.loadPeriodsByProgram().then(() => {
              this.refreshNotasFlowFlagAndUI();
            }).catch(e => {
              console.error(e);
              this.refreshNotasFlowFlagAndUI();
            });
            return;
          } else {
            this.clearPeriods();
          }

          this.refreshNotasFlowFlagAndUI();
          break;
        }
      }
    },
    UpdateUser() {
      //alert('UpdateUser');
      const certLabel = this.getSelectedCertificateLabel();
      const isNotas = this.isNotasCert(certLabel);
      const noData = !this.studentDataLoaded;
      this.refreshNotasFlowFlagAndUI();
      if (isNotas && this.isNotasNewFlow() && noData) {
        IberoHelpers.scrollToTop(0, 500);
        this.dialogServiceError = true;
        return false;
      }

      // Use promise form validation instead of await
      
      return this.$refs.obsformCertificate.validate().then(results => {
        if (!results) {
          //IberoHelpers.scrollToTop(0,500);
          //return false;
        }

        this.resetCertificateSubmitError();
        this.startAutomaticHomologationLookup(true);

        this.showDataInsert();
        this.FormCertificate = false;
        this.FormValidate = true;
        return true;
      }).catch(err => {
        alert(err);
        console.error(err);
        IberoHelpers.scrollToTop(0,500);
        return false;
      });
    },

    goBackForm: function(){
      this.FormValidate = false;
      this.FormCertificate = true;

      this.formInsModel.IdDocumentType = ''
      this.formInsModel.IdDocument = ''
      this.formInsModel.IdNombres = ''
      this.formInsModel.IdApellidos = ''
      this.formInsModel.IdBanner = ''
      this.formInsModel.IdCellphone = ''
      this.formInsModel.IdMail = ''
      this.formInsModel.UseNewCertificateEmail = false
      this.formInsModel.IdNewCertificateEmail = ''
      this.formInsModel.IdIberoMail = ''
      this.formInsModel.IdProgram = ''
      this.formInsModel.IdModality = ''
      this.formInsModel.IdWorking = ''
      this.formInsModel.IdPeriod = ''
      this.formInsModel.IdQuantity = ''
      this.formInsModel.IdPractice = ''
      this.formInsModel.IdSendType = 'Correo Electrónico'
      this.formInsModel.IdObservation = ''

      this.formInsModel.IsHomologation = false
      this.formInsModel.IsCurPeriod = false

      this.studentDataLoaded = false;
      this.dialogServiceError = false;
      this.pendingHomologationPromise = null;
      this.resetCertificateSubmitError();
      this.formInsModel.UseLegacyFlowNotas = false;
      this.setIdentityFieldsLocked(false);
      this.lastDocSnapshot = { type: "", doc: "" };
      this.toggleCellphoneField(false);
      this.toggleNewCertificateEmailField(false);

      this.restoreGlobalPrograms();
      this.clearPeriods();
      this.setFieldHidden("IdQuantity", true);
      this.setFieldHidden("IdPractice", true);

      this.refreshNotasFlowFlagAndUI();
    },

    showDataInsert: function(){
      this.NamePerson = this.formInsModel.IdNombres;
      this.LastnamePerson = this.formInsModel.IdApellidos;
      this.IdType = IberoHelpers.dataObjFind(this.$store.state.DocTypesList, this.formInsModel.IdDocumentType);
      this.Identification = this.formInsModel.IdDocument;

      const idx = this.formCertificate.findIndex(f => f.id === "IdProgram");
      const currentOptions = (idx !== -1 && this.formCertificate[idx].values)
        ? this.formCertificate[idx].values
        : this.$store.state.ProgramsList;

      this.Program = IberoHelpers.dataObjFind(currentOptions, this.formInsModel.IdProgram);

      this.CertificateType = IberoHelpers.dataObjFind(this.$store.state.CertificatesList, this.formInsModel.IdCertificateType);
      this.PeriodCertificate = this.formInsModel.IdPeriod;

      if(this.formInsModel.IdQuantity != ""){
        this.QuantityCertificate = this.formInsModel.IdQuantity;
        this.ValueCertificate = this.formInsModel.IdQuantity * 24575;
      } else {
        this.QuantityCertificate = 1;
        if (this.CertificateType == 'Certificado Giro Adicional'){
          this.ValueCertificate = 0;
        } else {
          this.ValueCertificate = 24575;
        }
      }
    },

    async onComplete(){
      let loader = this.$loading.show();

      try {
        this.resetCertificateSubmitError();
        this.refreshNotasFlowFlagAndUI();
        if (this.pendingHomologationPromise) {
          await this.pendingHomologationPromise;
        } else {
          await this.resolveAutomaticHomologation();
        }

        const payload = {
          ...this.formInsModel,
          IdIberoMail: this.getCertificateRecipientEmail(),
          PriceCertificate: String(this.ValueCertificate || 0),
        };

        const Response = await IberoHelpers.sendCaseCertificate(this.$store, payload);

        if (Response === false || !Response || !Response.data) {
          this.showCertificateSubmitError(Response);
          return false;
        }

        if (this.getCertificateSubmitStatus(Response) === '200') {
          IberoHelpers.scrollToTop(0,100);
          this.lastSuccessCertLabel = this.getSelectedCertificateLabel();
          this.lastSuccessUseLegacyNotasFlow = !!this.formInsModel.UseLegacyFlowNotas;

          this.goBackForm();
          this.simpleDialog = true;
          return true;
        }

        this.showCertificateSubmitError(Response);
        return false;
      } catch (error) {
        console.log(error);
        this.showCertificateSubmitError(error && error.response ? error.response : null, error && error.message ? error.message : "");
        return false;
      } finally {
        loader.hide();
      }
    },
  },

  data(){
    return {
      CERTS_REQUIRE_PERIOD: [
        "Certificado de Notas (Materias créditos y promedio semestral y general)",
      ],
      CERTS_AUTO_HOMOLOGATION: [
        "Certificado de Notas (Materias créditos y promedio semestral y general)",
      ],

      CERTS_SPECIAL_SUCCESS_MODAL: [
        "Certificado de Notas (Materias créditos y promedio semestral y general)",
      ],

      FormCertificate: true,
      FormValidate: false,
      infoData: false,
      infoCorrect: false,
      dangerData: false,
      dangerDataMessage: "",
      simpleDialog: false,
      dialogAditional: false,
      pendingHomologationPromise: null,

      dialogServiceError: false,
      studentDataLoaded: false,
      lastSuccessCertLabel: "",
      lastSuccessUseLegacyNotasFlow: false,
      lastDocSnapshot: { type: "", doc: "" },
      identityFieldsLocked: false,
      periodsLoading: false,
      periodsRequestId: 0,

      sumaryData: [],
      NamePerson: [],
      LastnamePerson: [],
      IdType: [],
      Identification: [],
      Program: [],
      CertificateType: [],
      PeriodCertificate: [],
      QuantityCertificate: [],
      ValueCertificate: [],

      formInsModel:{
        Campaign: this.$route.params.referencia,
        IdDocumentType: '',
        IdDocument: '',
        IdNombres: '',
        IdApellidos: '',
        IdBanner: '',
        IdCellphone: '',
        IdMail: '',
        UseNewCertificateEmail: false,
        IdNewCertificateEmail: '',
        IdIberoMail: '',
        IdProgram: '',
        IdPeriod: '',
        IdModality: '',
        IdWorking: '',
        IdCertificateType: '',
        IdQuantity: '',
        IdPractice: '',
        IdSendType: 'Correo Electrónico',
        IdObservation: '',
        IsHomologation: false,
        IsCurPeriod: false,
        UseLegacyFlowNotas: false,
      },

      formCertificate:[
        {
          id: 'IdDocumentType',
          model: 'IdDocumentType',
          type: 'Select',
          placeholder: "Tipo de Documento",
          values: this.$store.state.DocTypesList,
          validate: { required: true },
          class: 'col-md-6',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          type: 'input',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: { required: true, min: 5, max: 12 },
          class: 'col-md-6',
        },
        {
          id: 'IdNombres',
          model: 'IdNombres',
          type: 'input',
          placeholder: 'Nombres',
          values: '',
          readonly:"isReadOnly",
          validate: { required: true },
          class: 'col-md-6',
        },
        {
          id: 'IdApellidos',
          model: 'IdApellidos',
          type: 'input',
          placeholder: 'Apellidos',
          values: '',
          validate: { required: true },
          class: 'col-md-6'
        },
        {
          id: 'IdBanner',
          model: 'IdBanner',
          type: 'input',
          placeholder: 'Código Estudiantil',
          values: '',
          validate: { required: true, min: 5, max: 12 },
          class: 'col-md-6'
        },
        {
          id: 'IdCellphone',
          model: 'IdCellphone',
          type: 'input',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: { required: true, numeric: true, max: 10, min: 10 },
          class: 'col-md-6',
          hidden: false,
          disabled: false,
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          type: 'input',
          placeholder: 'Correo Personal',
          values: '',
          validate: { required: true, email: true },
          class: 'col-md-6'
        },
        {
          id: 'IdIberoMail',
          model: 'IdIberoMail',
          type: 'input',
          placeholder: 'Correo Institucional (opcional)',
          values: '',
          validate: { required: false, email: true },
          class: 'col-md-6'
        },
        {
          id: 'UseNewCertificateEmail',
          model: 'UseNewCertificateEmail',
          type: 'accepted',
          placeholder: '¿Desea agregar un email nuevo para recibir su certificado?',
          validate: { required: false },
          class: 'col-md-12'
        },
        {
          id: 'IdNewCertificateEmail',
          model: 'IdNewCertificateEmail',
          type: 'input',
          placeholder: 'Nuevo correo para recibir el certificado',
          values: '',
          validate: { required: false, email: true },
          class: 'col-md-6',
          hidden: true
        },
        {
          id: 'IdCertificateType',
          model: 'IdCertificateType',
          type: 'Select',
          placeholder: 'Tipo de Certificación o Duplicado',
          validate: { required: true },
          class: 'col-md-12',
          values: this.$store.state.CertificatesList,
        },
        {
          id: 'IdProgram',
          model: 'IdProgram',
          type: 'Select',
          placeholder: 'Programa a Certificar',
          validate: { required: true },
          class: 'col-md-12',
          values: this.$store.state.ProgramsList,
        },
        {
          id: 'IdPeriod',
          model: 'IdPeriod',
          type: 'Select',
          placeholder: 'Periodo Académico a Certificar',
          validate: { required: false },
          class: 'col-md-12',
          values: [],
          hidden: true,
          disabled: true,
        },
        {
          id: 'IsHomologation',
          model: 'IsHomologation',
          type: 'accepted',
          placeholder: '¿Es homologante?',
          validate: { required: false },
          class: 'col-md-12',
          hidden: true,
        },
        {
          id: 'IdQuantity',
          model: 'IdQuantity',
          hidden: true,
          type: 'Select',
          placeholder: 'Cantidad de Periodos',
          validate: { required: false },
          class: 'col-md-6',
          values: [
            { id: "1", value: "1" },
            { id: "2", value: "2" },
            { id: "3", value: "3" },
            { id: "4", value: "4" },
            { id: "5", value: "5" },
            { id: "6", value: "6" },
            { id: "7", value: "7" },
            { id: "8", value: "8" },
            { id: "9", value: "9" },
            { id: "10", value: "10" }
          ],
        },
        {
          id: 'IdPractice',
          model: 'IdPractice',
          hidden: true,
          type: 'input',
          placeholder: 'Sitio de Práctica',
          values: '',
          readonly:"isReadOnly",
          validate: { required: false },
          class: 'col-md-12',
        },
        {
          id: 'IdObservation',
          model: 'IdObservation',
          type: 'textarea',
          hint: "Max 500 caracteres",
          max: 500,
          placeholder: 'Mensaje',
          rows: 5,
          values: '',
          validate: { required: false },
          class: 'col-md-12',
          styleClasses: 'height: 200px'
        },
      ]
    }
  }
}
</script>

<style scope>
.infoTitleValid{
  font-size: 18px;
  margin: 0px 0px 0px 12px;
}
.InscPayOrder{
  margin: 20px;
}
.totalformList{
  margin-bottom: 10px;
}
.img-fluid{
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}

.txtBusUser{
  padding: 40px;
}

.titleRef {
  font-weight: bold;
  padding-bottom: 0px;
  margin-top: 20px;
}

.titleForm {
  color: #000;
}

.descriptionForm {
  padding: 10px 10px 0px 10px;
  font-size: 12px;
  margin: 0px;
}

.lisDataUser{
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #ffffff;
  background:  #ffffff !important;
  margin-bottom: 5px;
}

.container-form{
  padding: 30px 0;
  box-sizing: border-box;
}

.motBusUser{
  padding: 10px 10px 0px 10px;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 5px 5px 5px 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  background:  #ffffff !important;
}

body {
  background:  #fff !important;
}
header {
  background:  #ffffff !important;
}

.table > tbody > tr > td {
  vertical-align: middle !important;
}

.linksActas{
  padding: 20px;
  float: right;
}

.linksReference{
  margin-top: 20px;
  padding: 20px;
  float: right;
}

.linksActas a {
  color: #222;
}

.active
{
  color: #222;
}

#IdObservation {
  height: 90px;
}

.botoPnrocess {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 10px;
}
.period-loading-message {
  margin: 16px 0 0;
}
button:hover {
  background-color: #222;
  color: #fff;
}
.loginbtn {
  width: 90%;
  border: #222 solid 1px !important;
  background-color: #fff;
  color: #222;
  border-radius: 10px 10px;
  padding: 10px 0px 10px 0px;
}
.loginbtn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.validateBtn{
  width: 90%;
  border-color: #222;
  background-color: #fff;
  color: #222;
  border-radius: 10px 10px;
  padding: 10px 0px 10px 0px;
  margin: 0px 10px 10px 10px;
}

.InscFiles{
  margin: 20px;
}

.wrapper {
  display: grid;
  margin: 10px 10px 10px 10px;
  padding: 1px 1px 1px 1px;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid black;
  grid-gap: 1px;
  background-color: black;
}

.wrapper > div {
  background-color: white;
  padding: 10px;
  text-align: center;
}

#btnClose{
  margin: 10px 10px 10px 10px;
  border-radius: 5px;
  border-color: #222;
  background-color: #fff;
  color: #222;
}
#btnClose:hover{
  background-color: #222;
  color: #fff;
}
hr{
  margin: 5px 10px;
}
.titleModal{
  font-size: 20px !important;
}
.v-easy-dialog--transition-ease-in {
  transform: scale(1);
  transition: opacity cubic-bezier(0.4, 0, 1, 1) 0.15s,
    transform cubic-bezier(0.4, 0, 1, 1) 0.15s;
}
.v-easy-dialog--transition-ease-out {
  transform: scale(1);
  transition: opacity cubic-bezier(0, 0, 0.2, 1) 0.15s,
    transform cubic-bezier(0, 0, 0.2, 1) 0.15s;
}
.v-easy-dialog--content-transition-opened {
  opacity: 1;
  transform: scale(1);
}
.v-easy-dialog--content-transition-closed {
  opacity: 0;
  transform: scale(0);
}
.v-easy-dialog--opacity-0 {
  opacity: 0;
}
.v-easy-dialog--opacity-100 {
  opacity: 100;
}
.v-easy-dialog--backdrop {
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  touch-action: none;
}
.v-easy-dialog--backdrop-btn {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: default;
}
.v-easy-dialog--backdrop-btn:hover{
  background-color: rgba(0, 0, 0, 0) !important;
}
.v-easy-dialog--fullscreen {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.v-easy-dialog--content-grow *:first-child {
  flex-grow: 1;
}
.v-easy-dialog--content-container {
  display: flex;
  overflow-y: auto;
  position: absolute;
  touch-action: none;
}
.v-easy-dialog--content-container:focus {
  outline: none;
}
.v-easy-dialog--persist {
  animation: shake 0.15s;
}

.textSend{
  background-color: #fff;
  border-radius: 10px;
}

.textSend div p{
  padding: 10px 10px 10px 10px;
  margin: 0px 0px 0px 0px;
  color: #000;
  font-size: 15px;
}
@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
</style>
